export default __webpack_public_path__ + "static/media/chevron.95e98153.jpg";